<template>
  <div>
    <v-dialog v-model="show" width="500">
      <v-card>
        <v-card-text>
          <div v-html="message"></div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="close"> Fechar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "LoadingDialog",
  props: {
    show: Boolean,
    message: String
  },
  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>
